// Mount point for engagement tracking. Renders nothing.
//
// A COMPONENT RATHER THAN A HOOK CALL IN `App`, so the auth read and the route
// watch live together and `App` gains one line rather than three imports and a
// hook ordering constraint.
//
// It must sit INSIDE the router (it watches `useLocation`) and outside any
// route element (it has to survive navigation between them, or every route
// change would remount it and re-count the route it just arrived at).

import { useIsAuthenticated } from "@/lib/auth";
import { useEngagementSignals } from "./use-engagement";

export function EngagementTracker(): null {
  // Not `useConvexAuth`: this app mounts a plain `ConvexProvider`, so that hook
  // throws (`@/lib/auth`). Same reason `gloss-popover` uses this one.
  const isAuthenticated = useIsAuthenticated();
  useEngagementSignals(isAuthenticated);
  return null;
}
